/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_6_TitleInputs */

const en_privacy_section_6_title = /** @type {(inputs: Privacy_Section_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Data Retention`)
};

const lv_privacy_section_6_title = /** @type {(inputs: Privacy_Section_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Datu saglabāšana`)
};

/**
* | output |
* | --- |
* | "6. Data Retention" |
*
* @param {Privacy_Section_6_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_6_title = /** @type {((inputs?: Privacy_Section_6_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_6_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_6_title(inputs)
	return en_privacy_section_6_title(inputs)
});